<template>
  <div class="garden">
    <div class="toolbox row">
      <div id="divArea" class="f-left">
        <div
          v-bind:style="bgColor"
          @click="setAreaView()"
          class="f-color-white f-shadow-black f-bg-color-124384 f-size-18 f-hlh-40 f-p-l-lg f-p-r-lg f-r-sm f-left"
        >
          全市
        </div>
      </div>
      <div id="divAreacity" class="f-left" v-show="showCity">
        <div
          style="cursor: pointer; background-color: #0b5fb5"
          onclick="setAreacityView()"
          class="f-color-white f-shadow-black f-bg-color-124384 f-size-18 f-hlh-40 f-p-l-lg f-p-r-lg f-r-sm f-m-r"
        >
          {{ cityName }}
        </div>
      </div>
    </div>

    <div class="rightbox f-webkit-box f-box-vertical">
      <div
        class="gardendd f-size-18 f-color-white f-text-shadow f-r-sm f-shadow-black"
      >
        园区：
        <span class="f-size-18 f-color-white f-text-shadow" id="parkCount">{{
          gardenNumberAA
        }}</span
        >个
      </div>
      <div class="garden"></div>
      <div
        v-html="showHtml"
        class="f-color-59c8ff"
        style="
          position: absolute;
          top: 8px;
          left: -280px;
          padding: 48px 10px 8px 40px;
        "
        id="markerInfo"
      ></div>
      <div class="layui-panel f-p-xxs f-m-b-sm f-p-b" style="flex: 0.4">
        <div class="titlebg f-h-full f-webkit-box f-box-vertical">
          <div
            class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18"
          >
            全市园区企业数
          </div>
          <div
            class="zhibiao f-p-l-lg f-p-r-lg f-p-t-sm f-p-b f-webkit-box f-box-space-between"
          >
            <div
              class="f-webkit-box f-box-align-c f-box-pack-c f-box-flex1"
              v-for="(item, index) in qiYeShu"
              :key="index"
            >
              <div
                class="identifying iconfont f-m-r-xs f-color-008efc f-size-28"
              >
                &#xe6cd;
              </div>
              <div>
                <div class="f-color-64c6e7">
                  <span
                    class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                    id="endYearCompany"
                    >{{ item.count }}</span
                  >
                </div>
                <div class="f-color-64c6e7 f-size-14">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="f-m-t-xs f-m-b-xs layui-panel f-p-xxs f-box-flex1"
        style="height: 180px; flex: 0.8"
      >
        <div class="titlebg f-webkit-box f-box-vertical f-h-full">
          <div
            class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18"
          >
            全市园区经济指标
          </div>
          <div class="f-box-flex1 f-b-color-008efc f-webkit-box f-p-l">
            <div class="f-h-full f-p-t-xls">
              <div class="f-webkit-box f-p-t-sm f-p-b-sm">
                <div class="xgbg2 f-h-full">
                  <i class="iconfont icon2"></i>
                </div>
                <div class="f-m-l-sm">
                  <div class="f-color-white f-size-14">
                    <span
                      class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                      id="yqyysr"
                      >{{ yingYeShouRu }}</span
                    >亿元
                  </div>
                  <div class="f-color-2f85b1 f-size-14">全市园区营业收入</div>
                </div>
              </div>
            </div>
            <div
              class="f-box-flex1"
              id="main1_garden"
              style="height: 200px; margin-left: 40px"
            ></div>
          </div>
        </div>
      </div>
      <div class="f-m-t-xs f-m-b-xs layui-panel f-p-xxs" style="flex: 0.4">
        <div class="titlebg f-webkit-box f-box-vertical f-p-b">
          <div
            class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18"
          >
            全市园区土地使用情况
          </div>
          <div class="row f-p-l-lg f-p-r-lg f-p-t-sm f-p-b-xmd">
            <div id="tudimianji" style="height: 180px; padding-top: 20px"></div>
          </div>
        </div>
      </div>
      <div class="layui-panel f-p-xxs f-p-b-md f-m-t-sm">
        <div class="titlebg">
          <div
            class="layui-cards-title f-lh-36 f-color-white f-p-l-xlg f-size-18"
          >
            全市园区生产要素
          </div>
          <div class="row f-p-l-xlg f-p-r-xlg f-p-t">
            <div
              class="col-6 f-webkit-box f-box-align-c f-box-pack-c"
              v-for="(item, index) in shengChanYaoSu"
              :key="index"
            >
              <div class="identifying iconfont f-m-r f-color-008efc f-size-36">
                &#xe61a;
              </div>
              <div class="f-min-w-150">
                <div class="f-color-64c6e7">
                  <span
                    class="f-size-30 f-color-white f-m-r-xs f-text-shadow"
                    id="zhnyxhl"
                    >{{ item.count }}</span
                  >
                </div>
                <div class="f-color-64c6e7 f-size-14">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div
            class="row f-p-l-xlg f-p-r-xlg f-p-t"
            style="height: 140px"
          ></div>
        </div>
      </div>
    </div>
    <div class="bottombox">
      <div class="lbdjcz f-webkit-box">
        <div class="f-box-flex1 f-p-sm">
          <div class="f-webkit-box">
            <div class="layui-cutline f-box-flex1"></div>
            <div class="f-color-64c6e7 f-p-l-sm f-p-r-sm f-size-14">
              园区类别
            </div>
            <div class="layui-cutline f-box-flex1" layui-front="false"></div>
          </div>
          <div class="f-h-180" id="main4_garden"></div>
        </div>
        <div class="f-box-flex1 f-b-img f-p-sm">
          <div class="f-webkit-box">
            <div class="layui-cutline f-box-flex1"></div>
            <div class="f-color-64c6e7 f-p-l-sm f-p-r-sm f-size-14">
              园区等级
            </div>
            <div class="layui-cutline f-box-flex1" layui-front="false"></div>
          </div>
          <div class="f-h-180" id="main5_garden"></div>
        </div>
        <div class="f-box-flex1 f-p-sm">
          <div class="f-webkit-box">
            <div class="layui-cutline f-box-flex1"></div>
            <div class="f-color-64c6e7 f-p-l-sm f-p-r-sm f-size-14">
              园区产值
            </div>
            <div class="layui-cutline f-box-flex1" layui-front="false"></div>
          </div>
          <div class="f-h-180" id="main6_garden"></div>
        </div>
      </div>
      <div class="yqsl">
        <div class="f-webkit-box">
          <div class="layui-cutline f-box-flex1"></div>
          <div class="f-color-64c6e7 f-p-l-sm f-p-r-sm f-size-14">
            园区数量TOP5
          </div>
          <div class="layui-cutline f-box-flex1" layui-front="false"></div>
        </div>
        <div class="f-p-l-xs f-p-r-xs f-p-t-sm">
          <table class="yqsltp5">
            <colgroup>
              <col width="35" />
              <col width="75" />
              <col width="95" />
              <col />
            </colgroup>
            <tbody>
              <tr v-for="(v, k) in gardenNumber" :key="k">
                <td>
                  <div class="numbers">{{ k + 1 }}</div>
                </td>
                <td id="name5">{{ v.name }}</td>
                <td id="value5">{{ v.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div id="mapid1" style="width: 1290px; height: 800px" class="leftbox"></div>
  </div>
</template>

<script>
import Bus from "../bus.js";
import BMap from "BMap";
import { mapGetters } from "vuex";
export default {
  name: "garden",
  props: ["searchYearMonth"],
  data() {
    return {
      gardenNumber: [],
      gardenNumberAA: 0,
      qiYeShu: [],
      tuDiMianJi: [],
      shengChanYaoSu: [],
      yingYeShouRu: 0,
      endYearCompany: "--",
      highNewCompany: "--",
      reduceCompany: "--",
      zhnyxhl: "--",
      gyhsl: "--",
      fsdbpfl: "--",
      gtfwdbpfl: "--",
      ghmj: "--",
      yqyysr: "--",
      gytz: "--",
      showHtml: "",
      showCity: false,
      cityName: "",
      bgColor: {
        cursor: "pointer",
        background: "#0b5fb5",
      },
      month: this.searchYearMonth,
      baseNum: 7,
      bigNum: 8,
      dateValue: "",
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
    }),
  },
  watch: {
    searchYearMonth: function (val) {
      this.month = val;
      this.dateValue = val;
      console.log(this.month);
      // this.getData(this.month);
      this.getData(this.cityName, this.month);
      this.setIndex(this.cityName);
      // this.getProgyzjzByRank(this.month);
      // this.getProgyzjzByArea(this.month);
      // this.getProgytzTrend(this.month);
    },
  },
  created() {
    this.$axios
      .get("/business/mapSite/selectByType?type=gardenMap")
      .then((res) => {
        this.baseNum = res.data.data.baseNum;
        this.bigNum = res.data.data.bigNum;
        this.getMap(this.baseNum, this.bigNum);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  mounted() {
    this.dateValue = this.searchYearMonth;
    console.log("-----------", this.dateValue);
    this.$axios
      .get("/business/mapSite/selectByType?type=gardenMap")
      .then((res) => {
        this.baseNum = res.data.data.baseNum;
        this.bigNum = res.data.data.bigNum;
        this.getMap(this.baseNum, this.bigNum);
      })
      .catch((error) => {
        console.log(error);
      });
    this.setIndex("");
    this.checkhHtml5();
    this.getData("", this.month);
  },
  methods: {
    setAreaView() {
      window.location.reload();
    },

    getData(name, time) {
      //企业数
      this.$axios
        .get("/business/monitor/park/selectCityParkCount", {
          params: {
            districtName: name,
            dateRange: time,
          },
        })
        .then((res) => {
          var dataList = res.data.data;
          if (dataList[0] != null) {
            this.qiYeShu = dataList.slice(0, 3);
            this.tuDiMianJi = dataList.slice(3, 5);
            if (this.tuDiMianJi.length > 0) {
              this.areaEarch();
            }

            this.shengChanYaoSu = dataList.slice(5, 7);
          } else {
            this.qiYeShu = 0;
            this.tuDiMianJi = 0;
            if (this.tuDiMianJi.length > 0) {
              this.areaEarch();
            } else {
              this.tuDiMianJi = [];
              this.areaEarch();
            }

            this.shengChanYaoSu = 0;
          }
        });
      //全市园区经济指标数据  开始
      this.$axios
        .get("/business/monitor/park/selectCityProfitCount", {
          params: {
            districtName: name,
            dateRange: time,
          },
        })
        .then((res) => {
          if (res.data.data[0]) {
            this.yingYeShouRu = res.data.data[0].sum;
          }
        });
      //全市园区经济指标数据  结束
      //园区数量  开始
      this.$axios
        .get("/business/monitor/park/selectParkNumByDistrict", {
          params: {
            districtName: name,
          },
        })
        .then((res) => {
          this.gardenNumberAA = res.data.data;
        });
      //园区数量  结束
    },

    //厂区面积绘制

    areaEarch() {
      var chart = this.$echarts.init(document.getElementById("tudimianji"));
      let dataArr = [];
      for (let i = 0; i < this.tuDiMianJi.length; i++) {
        if (this.tuDiMianJi[i].name == "标准厂房面积") {
          dataArr[0] = this.tuDiMianJi[i].count;
        } else {
          dataArr[1] = this.tuDiMianJi[i].count;
        }
      }
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            textStyle: {
              color: "#fff",
            },
          },
        },
        title: {
          text: "",
          subtext: "",
        },
        legend: {
          textStyle: {
            color: "#90979c",
          },
          data: ["标准厂房面积", "入驻企业使用面积"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#90979c",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
          },
          splitArea: {
            show: false,
          },
        },
        yAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#90979c",
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitArea: {
            show: false,
          },
          axisLabel: {
            interval: 0,
          },
          data: [""],
        },
        series: [
          {
            name: "标准厂房面积",
            type: "bar",
            itemStyle: {
              normal: {
                color: "rgba(255,144,128,1)",
                label: {
                  show: true,
                  textStyle: {
                    color: "#fff",
                  },
                  position: "right",
                  formatter: function (p) {
                    return p.value > 0 ? p.value : "";
                  },
                },
              },
            },
            data: [dataArr[0]],
          },
          {
            name: "入驻企业使用面积",
            type: "bar",
            itemStyle: {
              normal: {
                color: "rgba(0,191,183,1)",
                barBorderRadius: 0,
                label: {
                  show: true,
                  position: "right",
                  formatter: function (p) {
                    return p.value > 0 ? p.value : "";
                  },
                },
              },
            },
            data: [dataArr[1]],
          },
        ],
      };
      chart.setOption(option);
    },

    //地图  开始
    getMap(baseNum, bigNum) {
      console.log(baseNum, bigNum);
      var that = this;
      var map = new BMap.Map("mapid1"); // 创建Map实例
      map.centerAndZoom(new BMap.Point(0, 0), 0); // 初始化地图,设置中心点坐标和地图级别
      var mapStyle = {
        features: ["road", "building", "water", "land"], //隐藏地图上的poi
        style: "midnight", //设置地图风格为高端黑
      };
      map.setMapStyle(mapStyle);

      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放

      var x = that.getUrlParam("x");
      var y = that.getUrlParam("y");
      var z = that.getUrlParam("z") || baseNum;

      map.addEventListener("mousemove", function (e) {
        x = e.point.lng;
        y = e.point.lat;
      });

      map.addEventListener("zoomend", function (e) {
        z = map.getZoom();
        if (z > baseNum) {
          that.showCity = true;
          that.$axios.jsonp = (url) => {
            if (!url) {
              return;
            }
            return new Promise((resolve, reject) => {
              window.jsonCallBack = (result) => {
                resolve(result);
              };
              var JSONP = document.createElement("script");
              JSONP.type = "text/javascript";
              JSONP.src = `${url}&callback=jsonCallBack`;
              document.getElementsByTagName("head")[0].appendChild(JSONP);
              setTimeout(() => {
                document.getElementsByTagName("head")[0].removeChild(JSONP);
              }, 500);
            });
          };
          that.$axios
            .jsonp(
              "http://api.map.baidu.com/geocoder/v2/?ak=MYmAqUe1VDAikSBA9a8XkP6R&location=" +
                y +
                "," +
                x +
                "&output=json&pois=1&callback=BMap._rd._cbk43398"
            )
            .then(function (res) {
              var result = res.result.addressComponent;
              that.cityName = result.city;
              that.bgColor.background = "#124384";
            });
        } else if (z < bigNum) {
          that.showCity = false;
          that.bgColor.background = "#0b5fb5";
          that.getData("", that.month);
        }
      });
      that.$axios.get("/business/monitor/park/selectParkNum").then((result) => {
        var resArr = result.data.data;
        console.log("*******************+++++++++++++++", resArr);
        var parks = resArr.filter((item) => {
          return (
            item.code !== "000000" && item.code !== that.seatList[0].parentCode
          );
        });
        console.log(parks);
        that.$axios
          .get(`/system/config/selectRegionAndVersion`)
          .then((result) => {
            if (result.data.data.region && result.data.data.version) {
              that.$axios
                .get(
                  `/system/config/selectConfigByRegionAndKeyAndVersion?region=${result.data.data.region}&key=json.url&version=${result.data.data.version}`
                )
                .then((result) => {
                  var url = `${result.data.data.value}${that.seatList[0].parentCode}.json`;

                  this.$http.get(url).then((res) => {
                    var result = res.body;
                    map.centerAndZoom(
                      new BMap.Point(
                        result.features[0].properties.center[0],
                        result.features[0].properties.center[1]
                      ),
                      z
                    );
                    var arr = result.features;
                    //绘制行政区划
                    var bdary = new BMap.Boundary();
                    //循环建立标注点
                    var markers = [];
                    for (var i = 0; i < arr.length; i++) {
                      that.getBoundary(arr[i].properties.name, bdary, map);
                      var x = arr[i].properties.center[0];
                      var y = arr[i].properties.center[1];
                      var no = arr[i].properties.adcode.toString().substr(0, 4);
                      var point = new BMap.Point(x, y); //将标注点转化成地图上的点
                      var marker = new BMap.Marker(point); //将点转化成标注点
                      // marker.name = parks[i].name;
                      marker.parkAreaNo = no;
                      marker.x = x;
                      marker.y = y;

                      for (var j = 0; j < parks.length; j++) {
                        if (parks[j].code == arr[i].properties.adcode) {
                          marker.name = parks[j].name;
                          marker.count = parks[j].count;
                        }
                      }
                      marker.disableMassClear();
                      var myIcon, label;
                      if (marker.count >= 10) {
                        myIcon = new BMap.Icon(
                          require("../../../assets/img/marker_red.png"),
                          new BMap.Size(36, 36)
                        );
                        label = new BMap.Label(
                          '<span style="color: #FFFFFF;">' +
                            marker.count +
                            "</span>",
                          {
                            offset: new BMap.Size(10, 5),
                          }
                        );
                      } else {
                        myIcon = new BMap.Icon(
                          require("../../../assets/img/marker_green.png"),
                          new BMap.Size(36, 36)
                        );
                        label = new BMap.Label(
                          '<span style="color: #128274;">' +
                            marker.count +
                            "</span>",
                          {
                            offset: new BMap.Size(14, 5),
                          }
                        );
                      }
                      marker.setIcon(myIcon);
                      map.addOverlay(marker); //将标注点添加到地图上
                      label.setStyle({
                        backgroundColor: "0", //文本标注背景颜色
                        border: "0",
                        fontWeight: "bold", //字体加粗
                      });
                      marker.setLabel(label);
                      markers.push(marker);
                    }

                    for (let i = 0; i < markers.length; i++) {
                      (function () {
                        markers[i].addEventListener("click", function () {
                          map.centerAndZoom(
                            new BMap.Point(this.x, this.y),
                            bigNum
                          );
                          map.setZoom(bigNum);
                          that.showBoundary(this.x, this.y, map);
                          that.cityName = this.name;
                          that.getData(that.cityName, that.month);
                          that.setIndex(that.cityName, that.month);
                          that.bgColor.background = "#124384";
                        });
                        //添加鼠标滑过时打开自定义信息窗口事件
                        markers[i].addEventListener("mouseover", function () {
                          marker.disableMassClear();
                          var res = "";
                          var color = this.count >= 10 ? "#f33c52" : "#0ee4bf";
                          res += '<ul class="ec-tooltip">';
                          res +=
                            '<div class="tooltipbg1"></div><div class="tooltipbg2"></div><div class="tooltipbg3" style="z-index: -1"></div><ul>';
                          res +=
                            '<li class="f-size-26 f-color-white"><br><b>' +
                            this.name +
                            "</b><br><br></li>";
                          res +=
                            '<li><span class="f-size-14"><i class="iconfont f-size-30">&#xe665;</i>园区数量</span><span class="f-size-20" style="color: ' +
                            color +
                            '"><b>' +
                            this.count +
                            "</b></span>个</li>";
                          res += "</ul>";
                          that.showHtml = res;
                          that.showBoundary(this.x, this.y, map);
                        });
                      })();
                    }
                  });
                });
            } else {
              return;
            }
          });
      });
    },

    tianjiabiaozhu(map) {},

    //获取url参数：
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg); //匹配目标参数
      if (r != null) return decodeURIComponent(r[2]);
      return null; //返回参数值
    },

    getBoundary(data, bdary, map) {
      bdary.get(data, function (rs) {
        //获取行政区域
        var count = rs.boundaries.length; //行政区域的点有多少个
        var pointArray = [];
        for (var i = 0; i < count; i++) {
          var ply = new BMap.Polygon(rs.boundaries[i], {
            strokeWeight: 2,
            strokeColor: "#01b1ed",
          }); //建立多边形覆盖物
          ply.setFillColor("none");
          ply.disableMassClear();
          map.addOverlay(ply); //添加覆盖物
        }
      });
    },

    showBoundary(x, y, map) {
      var bdary = new BMap.Boundary();
      var that = this;
      map.clearOverlays();
      this.$axios.jsonp = (url) => {
        if (!url) {
          return;
        }
        return new Promise((resolve, reject) => {
          window.jsonCallBack = (result) => {
            resolve(result);
          };
          var JSONP = document.createElement("script");
          JSONP.type = "text/javascript";
          JSONP.src = `${url}&callback=jsonCallBack`;
          document.getElementsByTagName("head")[0].appendChild(JSONP);
          setTimeout(() => {
            document.getElementsByTagName("head")[0].removeChild(JSONP);
          }, 500);
        });
      };
      this.$axios
        .jsonp(
          "http://api.map.baidu.com/geocoder/v2/?ak=MYmAqUe1VDAikSBA9a8XkP6R&location=" +
            y +
            "," +
            x +
            "&output=json&pois=1&callback=BMap._rd._cbk43398"
        )
        .then(function (res) {
          var result = res.result.addressComponent;

          bdary.get(result.district, function (rs) {
            //获取行政区域
            var count = rs.boundaries.length; //行政区域的点有多少个
            var pointArray = [];
            for (var i = 0; i < count; i++) {
              var ply = new BMap.Polygon(rs.boundaries[i], {
                strokeWeight: 5,
                strokeColor: "#ed2d2d",
              }); //建立多边形覆盖物
              ply.setFillColor("none");
              map.addOverlay(ply); //添加覆盖物
            }
          });
        });
    },

    //地图 结束

    //地图兼容提示  开始
    checkhHtml5() {
      if (typeof Worker === "undefined") {
        if (navigator.userAgent.indexOf("MSIE 9.0") <= 0) {
          alert(
            "定制个性地图示例：IE9以下不兼容，推荐使用百度浏览器、chrome、firefox、safari、IE10"
          );
        }
      }
    },
    //地图兼容结束

    setIndex(name) {
      var data1 = {
        title: "各市区营业收入",
        data: [],
      };
      var data3 = {
        title: "全市各市区园区工业投资",
        dataAxis: [],
        color: [
          ["rgba(2,210,171,1)", "rgba(5,112,44,1)"],
          ["rgba(1,167,226,1)", "rgba(5,99,171,1)"],
          "#008efb",
        ],
        data: [
          {
            name: "当期累计",
            data: [],
          },
          {
            name: "同期累计",
            data: [],
          },
          {},
        ],
      };
      var data4 = {
        unit: "%",
        data: [],
      };
      var data5 = {
        unit: "",
        data: [],
      };
      var data6 = {
        unit: "",
        data: [],
      };

      //园区类别  开始
      this.$axios
        .get("/business/monitor/park/selectParkStatisticsByDistrict", {
          params: {
            districtName: name,
          },
        })
        .then((res) => {
          var leiBie = res.data.data.园区类别;
          var dengJi = res.data.data.园区等级;
          var chanZhi = res.data.data.园区产值;
          var numberT5 = res.data.data.园区数量Top5;
          for (let i = 0; i < leiBie.length; i++) {
            if (leiBie[i].name == "") {
              leiBie[i].name = "未知";
            }
          }
          for (let i = 0; i < dengJi.length; i++) {
            if (dengJi[i].name == "") {
              dengJi[i].name = "未知";
            }
          }

          for (let i = 0; i < chanZhi.length; i++) {
            if (chanZhi[i].name == "") {
              chanZhi[i].name = "未知";
            }
          }
          for (let i = 0; i < numberT5.length; i++) {
            if (numberT5[i].name == "") {
              numberT5[i].name = "未知";
            }
          }

          var leiBieData = [];
          var dengJiData = [];
          var chanZhiData = [];
          var numberT5Data = [];

          function Obj(name, value) {
            //声明对象
            this.name = name;
            this.value = value;
          }
          for (let i = 0; i < leiBie.length; i++) {
            leiBieData.push(new Obj(leiBie[i].name, leiBie[i].count));
          }
          for (let i = 0; i < dengJi.length; i++) {
            dengJiData.push(new Obj(dengJi[i].name, dengJi[i].count));
          }
          for (let i = 0; i < chanZhi.length; i++) {
            chanZhiData.push(new Obj(chanZhi[i].name, chanZhi[i].count));
          }
          for (let i = 0; i < numberT5.length; i++) {
            numberT5Data.push(new Obj(numberT5[i].name, numberT5[i].count));
          }
          data4.data = leiBieData;
          data5.data = dengJiData;
          data6.data = chanZhiData;
          this.gardenNumber = numberT5Data;
          this.circle("main4_garden", data4);
          this.circle("main5_garden", data5);
          this.circle("main6_garden", data6);
        });
      //园区类别  结束

      //全市园区经济指标 开始
      this.$axios
        .get("/business/monitor/park/selectDistrictProfit", {
          params: {
            dateRange: this.month,
            districtName: name,
          },
        })
        .then((result) => {
          // result.data.data;
          var arrData = [];

          function Obj(name, value) {
            //声明对象
            this.name = name;
            this.value = value;
          }
          for (var i = 0; i < result.data.data.length; i++) {
            arrData.push(
              new Obj(result.data.data[i].district, result.data.data[i].sum)
            );
          }

          data1.data = arrData;
          this.pie("main1_garden", data1);
        });
      //全市园区经济指标 结束
    },

    //饼状图绘制  开始
    pie(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      var option = {
        color: ["#009944", "#e99b30", "#fe6327", "#007dfe", "#26c9ff"],
        title: {
          top: 5,
          left: "center",
          text: data.title,
          textStyle: {
            color: "#2375a1",
            fontSize: 14,
          },
        },
        tooltip: {
          trigger: "item",
          confine: true,
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "70%",
            center: ["50%", "57%"],
            data: data.data,
            label: {
              show: false,
              position: "inside",
              textBorderWidth: 0,
              fontSize: 10,
            },
          },
        ],
      };
      chart.setOption(option);
    },
    //饼状图绘制  结束

    //环状图绘制  开始
    circle(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      var legend = [];
      for (var i = 0; i < data.data.length; i++) {
        legend.push(data.data[i].name);
      }
      var option = {
        color: ["#009944", "#26c9ff", "#fe6327", "#e99b30", "#c03103"],
        tooltip: {
          trigger: "item",
          confine: true,
        },
        legend: {
          textStyle: {
            color: "#72a8db",
          },
          orient: "vertical",
          icon: "circle",
          itemWidth: 6,
          itemHeight: 6,
          top: "center",
          right: 0,
          data: legend,
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            center: ["35%", "55%"],
            data: data.data,
            label: {
              show: false,
              position: "inside",
              textBorderWidth: 0,
              fontSize: 10,
              formatter: "{c}" + data.unit,
            },
          },
        ],
      };
      chart.setOption(option);
    },
    //环状图绘制  结束

    //直方图绘制  开始
    bar(id, data) {
      var chart = this.$echarts.init(document.getElementById(id));
      var datas = data.data;
      var newdata = new Object();
      newdata.series = [];
      newdata.legend = [];
      for (var i = 0; i < datas.length; i++) {
        var d = datas[i];
        var color = data.color[i];
        if (d.hasOwnProperty("yIndex") && d.yIndex > 0) {
          newdata.series.push({
            name: d.name,
            type: "line",
            yAxisIndex: 1,
            data: d.data,
          });
        } else {
          newdata.legend.push(d.name);
          newdata.series.push({
            name: d.name,
            type: "bar",
            barCategoryGap: "45%",
            yAxisIndex: 0,
            data: d.data,
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: color[0], // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: color[1], // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
              },
            },
          });
        }
      }
      var option = {
        color: ["#008efb", "#FF7F4C", "#00FFFF", "#7396FF"],
        tooltip: {
          trigger: "axis",
          confine: true,
        },
        title: {
          top: 5,
          left: "center",
          text: data.title,
          textStyle: {
            color: "#2375a1",
            fontSize: 14,
          },
        },
        legend: {
          textStyle: {
            color: "#72a8db",
          },
          itemWidth: 6,
          itemHeight: 6,
          top: 24,
          data: newdata.legend,
        },
        grid: {
          top: 50,
          left: 20,
          right: 30,
          bottom: 20,
          containLabel: true,
        },
        yAxis: [
          {
            type: "value",
            name: "亿",
            nameGap: 10,
            nameTextStyle: {
              color: "#205da3",
              padding: [0, 20, 0, 0],
            },
            splitNumber: 4,
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: "#042c44",
              },
            },
            axisLabel: {
              color: "#205da3",
            },
            axisLine: {
              lineStyle: {
                color: "#0462aa",
              },
            },
          },
          {
            type: "value",
            name: "%",
            nameGap: 10,
            offset: 5,
            nameTextStyle: {
              color: "#205da3",
              padding: [0, 0, 0, 20],
            },
            splitNumber: 4,
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              color: "#205da3",
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#0462aa",
              },
            },
          },
        ],
        xAxis: {
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          boundaryGap: true,
          axisLabel: {
            color: "#205da3",
          },
          axisLine: {
            lineStyle: {
              color: "#0462aa",
            },
          },
          data: data.dataAxis,
        },
        series: newdata.series,
      };
      chart.setOption(option);
    },
    //直方图绘制  结束
  },
};
</script>

<style scoped="scoped">
.garden {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  padding-bottom: 40px;
  background: rgba(0, 0, 0, 0);
}

#mapid1 {
  width: 1290px;
  height: 709px;
  overflow: hidden;
  background-color: rgb(243, 241, 236);
  color: rgb(0, 0, 0);
  text-align: left;
  opacity: 0.85;
}

.mapbg {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(../../../assets/img/bg.png) center center no-repeat;
  background-size: 100% 100%;
  opacity: 0.7;
}

.gardendd {
  position: absolute;
  top: 8px;
  left: -180px;
  padding: 8px 10px 8px 40px;
  background: url(../../../assets/img/garden.png) 15px center no-repeat;
  background-color: #124384;
  width: 170px;
}
</style>